export const messages = {
  en: {
    repairForceFinishManage: {
      searchCondition: 'Search Conditions',
      repairTypePlaceholder: 'Select Repair Type',
      repairPersonPlaceholder: 'Enter Repair Person',
      repairPhonePlaceholder: 'Enter Repair Phone',
      search: 'Search',
      reset: 'Reset',
      forceFinish: 'Force Finish',
      repairId: 'Work Order ID',
      location: 'Location',
      repairType: 'Repair Type',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      submitTime: 'Submit Time',
      status: 'Status',
      operation: 'Operation',
      detail: 'Detail',
      description: 'Description: This function is mainly used to solve the scenario where the maintenance master is too old to use the mobile phone operation, and the customer service personnel need to confirm the maintenance completion and force the order back'
    },
    forceFinishRepair: {
      title: 'Force Finish',
      useMaterial: 'Use Material?',
      maintenanceType: 'Maintenance Type',
      goodsType: 'Goods Type',
      goodsName: 'Goods Name',
      customPrice: 'Custom Price',
      secondaryCategory: 'Secondary Category',
      goods: 'Goods',
      goodsPrice: 'Goods Price',
      priceRange: 'Price Range',
      specification: 'Specification',
      quantity: 'Quantity',
      paymentMethod: 'Payment Method',
      explanation: 'Explanation',
      submit: 'Submit',
      cancel: 'Cancel'
    },
    chooseSingleResource: {
      title: 'Select Item',
      goodsType: 'Goods Type',
      secondaryCategory: 'Secondary Category',
      goods: 'Goods',
      goodsPrice: 'Goods Price',
      priceRange: 'Price Range',
      specification: 'Specification',
      quantity: 'Quantity',
      confirm: 'Confirm',
      cancel: 'Cancel'
    }
  },
  zh: {
    repairForceFinishManage: {
      searchCondition: '查询条件',
      repairTypePlaceholder: '请选择报修类型',
      repairPersonPlaceholder: '请输入报修人',
      repairPhonePlaceholder: '请输入报修电话',
      search: '查询',
      reset: '重置',
      forceFinish: '强制回单',
      repairId: '工单编号',
      location: '位置',
      repairType: '报修类型',
      repairPerson: '报修人',
      contact: '联系方式',
      appointmentTime: '报修时间',
      submitTime: '提交时间',
      status: '状态',
      operation: '操作',
      detail: '详情',
      description: '说明：此功能主要为了解决维修师傅年龄大不会使用手机操作，需要客服人员确认维修完后强制回单场景'
    },
    forceFinishRepair: {
      title: '强制回单',
      useMaterial: '是否用料',
      maintenanceType: '维修类型',
      goodsType: '商品类型',
      goodsName: '商品名',
      customPrice: '自定义价格',
      secondaryCategory: '二级分类',
      goods: '商品',
      goodsPrice: '商品价格',
      priceRange: '价格范围',
      specification: '规格',
      quantity: '商品数量',
      paymentMethod: '支付方式',
      explanation: '说明',
      submit: '提交',
      cancel: '取消'
    },
    chooseSingleResource: {
      title: '选择物品',
      goodsType: '商品类型',
      secondaryCategory: '二级分类',
      goods: '商品',
      goodsPrice: '商品价格',
      priceRange: '价格范围',
      specification: '规格',
      quantity: '商品数量',
      confirm: '确定',
      cancel: '取消'
    }
  }
}